<div class="modal-overlay">
  <div class="modal-content">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeModal()">&times;</button>

    <div class="modal-header">
      <h2>{{ mode === 'edit' ? ('assign.modalEditTitle' | t:'Edit Assign Flat') : ('assign.modalNewTitle' | t:'Assign Flat') }}</h2>
    </div>

    <form class="assign-form" (ngSubmit)="submitForm()">
      <div class="form-row two-col">
        <div class="form-group">
          <app-common-dropdown
            [dropdownObj]="houseFilterDropdownObj"
            [value]="selectedHouseId"
            (valueChange)="onHouseFilterChange($event)"
          ></app-common-dropdown>
        </div>

        <div class="form-group">
          <app-common-dropdown
            [dropdownObj]="floorFilterDropdownObj"
            [value]="selectedFloorName"
            (valueChange)="onFloorFilterChange($event)"
          ></app-common-dropdown>
        </div>
      </div>

      <div class="form-row two-col">
        <div class="form-group">
          <app-common-dropdown
            [dropdownObj]="flatDropdownObj"
            [requestFilters]="flatDropdownFilters"
            [value]="assign.flatId"
            (valueChange)="onFlatChange($event)"
            (optionsLoaded)="onFlatOptionsLoaded($event)"
          ></app-common-dropdown>
        </div>

        <div class="form-group">
          <app-common-dropdown
            [dropdownObj]="renterDropdownObj"
            [value]="assign.renterId"
            (valueChange)="onRenterChange($event)"
          ></app-common-dropdown>
        </div>
      </div>

      <div class="form-row two-col">
        <div class="form-group">
          <label>{{ 'assign.renterStartDate' | t:'Renter Start Date' }} *</label>
          <div class="date-input-wrap">
            <input
              type="text"
              class="date-input"
              [(ngModel)]="assign.renterStartDate"
              name="renterStartDate"
              [placeholder]="'placeholder.selectDate' | t:'Select date'"
              maxlength="10"
              readonly
              (click)="picker.open()"
              required
            />
            <button
              type="button"
              class="date-picker-btn"
              [attr.aria-label]="'placeholder.selectDate' | t:'Pick date'"
              (click)="picker.open()"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1Zm13 8H4v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8ZM5 6a1 1 0 0 0-1 1v1h16V7a1 1 0 0 0-1-1H5Z"/>
              </svg>
            </button>
            <input
              matInput
              [matDatepicker]="picker"
              [value]="matDateValue"
              class="mat-date-anchor"
              (dateChange)="onDateSelected($event)"
              tabindex="-1"
              aria-hidden="true"
            />
            <mat-datepicker #picker></mat-datepicker>
          </div>
        </div>

        <div class="form-group">
          <label>{{ 'assign.advanceAmount' | t:'Advance Amount' }}</label>
          <input
            type="number"
            min="0"
            [(ngModel)]="assign.advanceAmount"
            name="advanceAmount"
            [placeholder]="'placeholder.typeAdvanceAmount' | t:'Type advance amount'"
          />
        </div>
      </div>

      <div class="form-row two-col" *ngIf="mode === 'edit'">
        <div class="form-group">
          <label>{{ 'assign.endDateOptional' | t:'End Date (Optional)' }}</label>
          <div class="date-input-wrap">
            <input
              type="text"
              class="date-input"
              [(ngModel)]="assign.renterEndDate"
              name="renterEndDate"
              [placeholder]="'placeholder.selectEndDateOptional' | t:'Select end date (optional)'"
              maxlength="10"
              readonly
              (click)="pickerEnd.open()"
              [class.date-input-has-clear]="assign.renterEndDate"
            />
            <button
              *ngIf="assign.renterEndDate"
              type="button"
              class="date-clear-btn"
              [attr.aria-label]="'common.clearSelection' | t:'Clear end date'"
              (click)="clearEndDate()"
            >
              &times;
            </button>
            <button
              type="button"
              class="date-picker-btn"
              [attr.aria-label]="'placeholder.selectEndDateOptional' | t:'Pick end date'"
              (click)="pickerEnd.open()"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1Zm13 8H4v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8ZM5 6a1 1 0 0 0-1 1v1h16V7a1 1 0 0 0-1-1H5Z"/>
              </svg>
            </button>
            <input
              matInput
              [matDatepicker]="pickerEnd"
              [value]="matEndDateValue"
              class="mat-date-anchor"
              (dateChange)="onEndDateSelected($event)"
              tabindex="-1"
              aria-hidden="true"
            />
            <mat-datepicker #pickerEnd></mat-datepicker>
          </div>
          <div class="field-hint">{{ 'assign.endDateHint' | t:'For unassign, provide End Date. In edit, this field is optional.' }}</div>
        </div>
      </div>

      <div class="form-actions">
        <div class="form-message error" *ngIf="error">{{ error }}</div>
        <button
          *ngIf="mode === 'edit'"
          class="agreement-doc-btn"
          type="button"
          (click)="openDocumentUpdate()"
          [disabled]="isSubmitting"
        >
          {{ 'assign.agreementDocumentUpdate' | t:'Update Additional Documents' }}
        </button>
        <button class="PositiveBTN" type="submit" [disabled]="isSubmitting">
          {{ isSubmitting ? ('common.saving' | t:'Saving...') : (mode === 'edit' ? ('assign.updateButton' | t:'Update Assign') : ('assign.addButton' | t:'Assign Flat')) }}
        </button>
      </div>
    </form>
  </div>
</div>
